import React from 'react';
import { SiteContent } from '../data/content';

interface ProofScaleProps {
  content: SiteContent['proofScale'];
  showAll?: boolean;
}

export const ProofScale: React.FC<ProofScaleProps> = ({ content, showAll = false }) => {
  const displayItems = showAll
    ? [...content.items, ...content.extendedItems]
    : content.items;

  return (
    <section className="proof-section" id="proof" aria-labelledby="proof-title">
      <div className="container">
        <div className="section-head">
          <p className="eyebrow">{content.eyebrow}</p>
          <h2 id="proof-title" className="section-title">
            {content.title}
          </h2>
        </div>

        <div className="proof-editorial-grid">
          {displayItems.map((item) => (
            <div key={item.id} className="proof-editorial-row">
              <div className="proof-num-block">
                <span className="proof-index">{item.index}</span>
                <strong className="proof-stat-number">{item.stat}</strong>
              </div>
              <div className="proof-label-block">
                <h3 className="proof-label-text">{item.label}</h3>
                <p className="proof-context-text">{item.context}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
